import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../../Services/axios';
import './PaymentModal.scss';

const PaymentModal = ({ onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('initial'); // initial, processing, success, error
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    // Check if returning from Stripe
    const urlParams = new URLSearchParams(window.location.search);
    const returnedSessionId = urlParams.get('session_id');
    const canceled = urlParams.get('canceled');

    console.log('[PAYMENT-MODAL] URL Params:', { returnedSessionId, canceled });

    if (returnedSessionId) {
      console.log('[PAYMENT-MODAL] Returned from Stripe with sessionId:', returnedSessionId);
      verifyPayment(returnedSessionId);
    } else if (canceled) {
      console.log('[PAYMENT-MODAL] Payment was canceled');
      setStatus('error');
      setError('Payment was canceled. Please try again.');
    }
  }, []);

  const verifyPayment = async (sessionId) => {
    console.log('[PAYMENT-MODAL] Starting verification for sessionId:', sessionId);
    setIsLoading(true);
    try {
      console.log('[PAYMENT-MODAL] Calling /brain-snap/stripe/session-status/' + sessionId);
      const response = await axiosInstance.get(`/brain-snap/stripe/session-status/${sessionId}`);

      console.log('[PAYMENT-MODAL] Verification response:', response.data);

      if (response.data.success && response.data.status === 'completed') {
        console.log('[PAYMENT-MODAL] Payment completed successfully!');
        setStatus('success');
        // Auto-close and reload after 2 seconds
        setTimeout(() => {
          // Clean up URL
          window.history.replaceState({}, document.title, window.location.pathname);
          if (onSuccess) {
            console.log('[PAYMENT-MODAL] Calling onSuccess callback');
            onSuccess();
          }
        }, 2000);
      } else {
        console.log('[PAYMENT-MODAL] Payment still processing - status:', response.data.status);
        setStatus('processing');
        setError('Payment is still processing. Please wait...');
      }
    } catch (err) {
      console.error('[PAYMENT-MODAL] Error verifying payment:', err);
      setStatus('error');
      setError(err.response?.data?.message || 'Failed to verify payment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePurchase = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post('/brain-snap/stripe/create-checkout-session');

      if (response.data.success && response.data.url) {
        // Redirect to Stripe Checkout
        window.location.href = response.data.url;
      } else {
        setStatus('error');
        setError('Failed to create checkout session. Please try again.');
      }
    } catch (err) {
      console.error('Error creating checkout session:', err);
      setStatus('error');
      setError(err.response?.data?.message || 'Failed to initiate payment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ✕
        </button>

        {status === 'success' ? (
          <div className="modal-content success-state">
            <div className="success-icon">✓</div>
            <h2>Payment Successful!</h2>
            <p>Welcome to Pro! 10 image generations added to your account.</p>
            <p className="small-text">Redirecting in a moment...</p>
          </div>
        ) : status === 'error' && !sessionId ? (
          <div className="modal-content error-state">
            <div className="error-icon">✕</div>
            <h2>Payment Canceled</h2>
            <p>{error}</p>
            <button className="retry-button" onClick={handlePurchase} disabled={isLoading}>
              Try Again
            </button>
          </div>
        ) : (
          <div className="modal-content">
            <div className="pricing-section">
              <h2>Unlock Pro</h2>

              <div className="price-display">
                <div className="price-amount">$10.00</div>
                <div className="price-label">One-time payment</div>
              </div>

              <div className="plan-details">
                <div className="detail-item">
                  <span className="detail-icon">✓</span>
                  <span>10 Image Generations</span>
                </div>
                <div className="detail-item">
                  <span className="detail-icon">✓</span>
                  <span>Never Expires</span>
                </div>
                <div className="detail-item">
                  <span className="detail-icon">✓</span>
                  <span>Priority Processing</span>
                </div>
              </div>
            </div>

            {error && (
              <div className="error-message">
                <span>⚠️ {error}</span>
              </div>
            )}

            <button
              className="purchase-button"
              onClick={handlePurchase}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Processing...
                </>
              ) : (
                'Get Pro Access'
              )}
            </button>

            <div className="payment-footer">
              <div className="payment-methods">
              </div>
              <p className="security-notice">
                🔒 Secure payment powered by Stripe
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
